import { render } from "./facebook-button.vue?vue&type=template&id=027927c8"
import script from "./facebook-button.vue?vue&type=script&lang=js"
export * from "./facebook-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__